<template>
  <wrap-container>
    <help-title title="Pedido de formularios" />

    <help-list-container>
      <help-list-item tituloLista="Descargá formularios:">
        Descargá el formulario que necesites desde nuestro sitio.
        <custom-link
          label="Ver formularios"
          href="https://www.bbva.com.ar/personas/productos/comex/formularios.html"
        />
      </help-list-item>

      <help-list-item tituloLista="Más información:">
        Encontrá más información sobre comercio exterior en nuestro sitio
        <custom-link
          label="Ver más Información"
          href="https://www.bbva.com.ar/personas/productos/comex.html"
        />
      </help-list-item>

      <help-list-item tituloLista="¿No resolvimos tu consulta?">
        Podés dejar tus datos y un representante se podrá en contacto a la
        brevedad.
        <p id="contactForm" @click="contacto">Quiero que me contacten</p>
        <div v-if="show">
          <br />
          <formulario-contacto />
        </div>
      </help-list-item>
    </help-list-container>
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import HelpTitle from "@/components/core/HelpTitle";
import HelpListItem from "@/components/core/HelpListItem";
import HelpListContainer from "@/components/core/HelpListContainer";
import CustomLink from "@/components/core/CustomLink";
import FormularioContacto from "@/views/segments/subSegments/FormularioContacto.vue";

export default {
  components: {
    WrapContainer,
    HelpTitle,
    HelpListItem,
    HelpListContainer,
    CustomLink,
    FormularioContacto
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    contacto: function() {
      this.show = true;
    }
  }
};
</script>

<style>
#contactForm {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
</style>
